/**
 * RESPONSIBILITY: the words on the contact-requests page, the one an admin works through.
 *
 * Only words. The requests themselves are not a section - they are what visitors sent,
 * and a section is what an editor writes - see contact-routes.ts.
 *
 * No @EditableBy, so WRITE defaults to NONE - admin only, which is also who sees the page.
 */
import { Section, Text } from '@framework/core/decorators';
import { SectionName } from '../section-names';

@Section({ name: SectionName.Requests, label: 'Contact requests - Wording' })
export class RequestsSection {
  @Text({ label: 'Title', maxLength: 120, default: 'Contact requests' })
  heading!: string;

  @Text({ label: 'Waiting tab', maxLength: 60, default: 'Waiting' })
  queueLabel!: string;

  @Text({ label: 'Archive tab', maxLength: 60, default: 'Archive' })
  archiveLabel!: string;

  @Text({ label: 'Done button', maxLength: 60, default: 'Done', description: 'The tick: moves a request to the archive.' })
  doneLabel!: string;

  @Text({ label: 'Redo button', maxLength: 60, default: 'Redo', description: 'Puts an archived request back in the waiting list.' })
  redoLabel!: string;

  @Text({ label: 'Note button', maxLength: 60, default: 'Note' })
  noteLabel!: string;

  @Text({ label: 'Save note button', maxLength: 60, default: 'Save' })
  saveLabel!: string;

  @Text({ label: 'Cancel button', maxLength: 60, default: 'Cancel' })
  cancelLabel!: string;

  @Text({ label: 'Nothing waiting', maxLength: 200, default: 'Nothing waiting. All caught up.' })
  emptyQueue!: string;

  @Text({ label: 'Nothing archived', maxLength: 200, default: 'Nothing in the archive yet.' })
  emptyArchive!: string;

  @Text({ label: 'Not signed in', maxLength: 200, default: 'Sign in as an administrator to see these.' })
  signInMessage!: string;

  @Text({ label: 'Could not load', maxLength: 200, default: 'Could not load the requests. Try again in a moment.' })
  failedMessage!: string;
}
